import React from 'react'

export const DropdownButton = (props: { onClick?: React.MouseEventHandler; children?: React.ReactNode }) => {
  return (
    <button onClick={props.onClick} className="generic-dropdown-button flex-1">
      {props.children}
    </button>
  )
}
